import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/section-title.module.css';

interface SectionTitleProps extends TypographyProps {
    colored?: boolean;
    brand?: string | null;
}

function SectionTitle({ tag, brand, colored = false, className, ...props }: SectionTitleProps) {
    return (
        <Typography
            tag={tag}
            className={classNames([
                styles.container,
                {
                    [styles.colored]: colored,
                },
                className,
            ])}
            data-brand={brand}
            {...props}
        />
    );
}

export default SectionTitle;
